export const initialState = {
  warning: null,
  isIntroModalOpen: true,
  isBusinessPlanModalOpen: false,
  isConclusionsModalOpen: false,
  businessPlanModalStep: 0,
  conclusionsModalStep: 0
}

export function tutorReducer(state = initialState, action) {
  switch (action.type) {
    case 'tutor/setWarning':
      return { ...state, warning: action.payload }
    case 'tutor/clearWarning':
      return { ...state, warning: null }
    case 'tutor/setIntroModalOpen':
      return { ...state, isIntroModalOpen: action.payload }
    case 'tutor/setBusinessPlanModalOpen':
      return { ...state, isBusinessPlanModalOpen: action.payload }
    case 'tutor/setBusinessPlanModalStep':
      return { ...state, businessPlanModalStep: action.payload }
    case 'tutor/setConclusionsModalOpen':
      return { ...state, isConclusionsModalOpen: action.payload }
    case 'tutor/setConclusionsModalStep':
      return { ...state, conclusionsModalStep: action.payload }
    default:
      return state
  }
}

export default tutorReducer

export const setWarning = (message, type = 'action') => ({
  type: 'tutor/setWarning',
  payload: { message, type }
})

export const clearWarning = () => ({
  type: 'tutor/clearWarning'
})

export const setIntroModalOpen = (isOpen) => ({
  type: 'tutor/setIntroModalOpen',
  payload: isOpen
})

export const setBusinessPlanModalOpen = (isOpen) => ({
  type: 'tutor/setBusinessPlanModalOpen',
  payload: isOpen
})

export const setBusinessPlanModalStep = (step) => ({
  type: 'tutor/setBusinessPlanModalStep',
  payload: step
})

export const setConclusionsModalOpen = (isOpen) => ({
  type: 'tutor/setConclusionsModalOpen',
  payload: isOpen
})

export const setConclusionsModalStep = (step) => ({
  type: 'tutor/setConclusionsModalStep',
  payload: step
})
